import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { fetchGymUsers, fetchGymMembersFromExplorer } from '../fetchers/gyms';
import { useDebounce } from '../../components/atom/search';

export function useGymUsers(uid, searchTerm, params, useMemberExplorer = false) {
  const debouncedInputValue = useDebounce(searchTerm, 300);
  const fetchUsers = useMemberExplorer
    ? fetchGymMembersFromExplorer
    : fetchGymUsers;
  const { data, isLoading, error } = useQuery(
    ['gym-users', useMemberExplorer ? 'member-explorer' : 'legacy', debouncedInputValue, uid, params],
    () => fetchUsers(uid, debouncedInputValue, params),
    {
      refetchOnWindowFocus: true,
      enabled: !!uid,
    }
  );

  const [users, setUsers] = useState([]);

  useEffect(() => {
    const setUsersData = (data) => {
      setUsers(data);
    };
    setUsersData(data);
  }, [data]);

  return {
    users,
    setUsers: setUsers,
    loading: isLoading,
    error,
  };
}

export function useGymMembersFromExplorer(uid, searchTerm, params) {
  const debouncedInputValue = useDebounce(searchTerm, 300);
  const { data, isLoading, error } = useQuery(
    ['gym-members-explorer', debouncedInputValue, uid, params],
    () => fetchGymMembersFromExplorer(uid, debouncedInputValue, params),
    {
      refetchOnWindowFocus: true,
      enabled: !!uid,
    }
  );

  const [users, setUsers] = useState([]);

  useEffect(() => {
    setUsers(data);
  }, [data]);

  return {
    users,
    setUsers,
    loading: isLoading,
    error,
  };
}
